import {
  WithdrawableBalance,
  PendingBalance,
  PayoutHistoryItem,
  PaginatedPayoutHistory,
} from "../../domain/types";
import {
  V2WithdrawableBalanceData,
  V2PendingBalanceData,
  V2PayoutHistoryData,
  V2PayoutHistoryItem,
} from "./mapper.types";

/**
 * Maps v2 API responses to domain types.
 * v2 API uses camelCase and provides full pagination support.
 *
 * Pure TypeScript - no React imports.
 */
export const PayoutMapperV2 = {
  /**
   * Maps v2 balance response to domain WithdrawableBalance.
   * Note: v2 returns balance as a string, needs parsing.
   * v2 doesn't return currency in withdrawable balance - must be passed in.
   */
  toWithdrawableBalance(
    data: V2WithdrawableBalanceData,
    currency = "NGN"
  ): WithdrawableBalance {
    return {
      balance: parseFloat(data.balance) || 0,
      currency,
    };
  },

  /**
   * Maps v2 pending balance response to domain PendingBalance.
   */
  toPendingBalance(data: V2PendingBalanceData): PendingBalance {
    return {
      pendingBalance: data.pendingBalance,
      currency: data.currency,
    };
  },

  /**
   * Maps v2 payout history item to domain PayoutHistoryItem.
   */
  toPayoutHistoryItem(item: V2PayoutHistoryItem): PayoutHistoryItem {
    return {
      id: item.id,
      createdAt: item.createdAt,
      amount: item.amount,
      fee: item.fee,
      currency: item.currency,
      reference: item.reference,
      statusName: item.statusName,
      transactionType: item.transactionType,
    };
  },

  /**
   * Maps v2 payout history response to domain PaginatedPayoutHistory.
   */
  toPayoutHistory(data: V2PayoutHistoryData): PaginatedPayoutHistory {
    return {
      data: data.data.map(PayoutMapperV2.toPayoutHistoryItem),
      total: data.total,
      hasNextPage: data.hasNextPage,
      hasPrevPage: data.hasPrevPage,
    };
  },
};
